var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorLightBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 52,
    viewBox: "0 0 62 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2823_7820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5 29.2727C53.5 45.8182 31 60 31 60C31 60 8.5 45.8182 8.5 29.2727C8.5 23.6308 10.8705 18.22 15.0901 14.2306C19.3097 10.2412 25.0326 8 31 8C36.9674 8 42.6903 10.2412 46.9099 14.2306C51.1295 18.22 53.5 23.6308 53.5 29.2727Z",
    fill: "#CE2424"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2823_7820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1065 18.1164C37.4883 17.7794 36.7793 17.6552 36.0857 17.7623L22.0402 19.7673C19.9497 20.0683 18.2555 22.1619 18.2512 24.4591L18.225 39.8577C18.197 40.5097 18.3444 41.1571 18.6513 41.7303C18.9583 42.3035 19.4132 42.7808 19.9671 43.1109L24.5749 45.6604C24.022 45.3292 23.5679 44.8516 23.2611 44.2787C22.9543 43.7057 22.8063 43.0589 22.8328 42.4071L22.8633 27.0218C22.8633 24.7291 24.5619 22.6355 26.6524 22.3345L40.6979 20.3117C41.39 20.2047 42.0977 20.3289 42.7143 20.6658L38.1065 18.1164Z",
    fill: "#E48A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0069 19.9729C42.093 19.6764 43.7828 21.3008 43.7785 23.5803L43.7523 38.9833C43.7523 41.2761 42.0495 43.3741 39.9633 43.675L25.9178 45.6801C23.8273 45.9766 22.1418 44.3522 22.1418 42.0728L22.1723 26.683C22.1723 24.3902 23.8709 22.2967 25.9614 21.9957L40.0069 19.9729Z",
    fill: "#EFF5F2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2823_7820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1326 25.9849L27.4526 34.1314H33.4646L32.7966 39.5624L39.4765 31.4159H33.4646L34.1326 25.9849Z",
    fill: "#CE2424"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2823_7820",
    x: 0.5,
    y: 0,
    width: 61,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.34902 0 0 0 0 0.356863 0 0 0 0 0.392157 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2823_7820"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2823_7820",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2823_7820",
    x: 16.2217,
    y: 15.7249,
    width: 33.5569,
    height: 35.9902,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.87451 0 0 0 0 0.27451 0 0 0 0 0.27451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2823_7820"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2823_7820",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2823_7820",
    x: 23.4526,
    y: 23.9849,
    width: 20.0239,
    height: 21.5776,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.180392 0 0 0 0 0.188235 0 0 0 0 0.215686 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2823_7820"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2823_7820",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorLightBox);
export default __webpack_public_path__ + "static/media/error_light_box.751429f10fd079b76bcfb29e082c765e.svg";
export { ForwardRef as ReactComponent };